import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import hexImg from '../images/ImageUpload/hexImg.png'
import colorJSON from './colors.json'

function UpdateColors() {

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const [colors, setColors] = useState([])
    // const [modifiedColorsFromDB, setModifiedColorsFromDB] = useState([])

    // console.log(colors, 'colors');


    useEffect(() => {
        const fetchColorSizeData = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllColorSize/BLACKBATON_2526`);
                const data = await response.json();

                // Extract unique colors and sizes
                const uniqueColors = [...new Set(data.map(item => item.Color))];

                setColors(uniqueColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };

        const fetchModfiedColors = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const data = await response.json();
                // console.log(data, 'data');

                const modifiedColors = data.reduce((acc, item) => {
                    acc[item.db_color] = {
                        name: item.md_color?.toUpperCase() || '',
                        hex: item.hex || ''
                    };
                    return acc;
                }, {});

                setModifiedColors(modifiedColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };

        fetchColorSizeData();
        fetchModfiedColors()
    }, [apiBaseUrl]);

    const [modifiedColors, setModifiedColors] = useState({});

    const handleChangeColor = (e, color) => {
        const val = e.target.value.toUpperCase();

        setModifiedColors(prev => ({
            ...prev,
            [color]: {
                ...(prev[color] || {}),
                name: val
            }
        }));
    };

    const handleChangeHex = (e, color) => {
        const val = e.target.value;

        setModifiedColors(prev => ({
            ...prev,
            [color]: {
                ...(prev[color] || {}),
                hex: val
            }
        }));
    };

    const [loadingColors, setLoadingColors] = useState({});

    const [respectedColorList, setRespectedColorList] = useState([])


    const handleGetHexCodes = async (color) => {

        if (respectedColorList[color]) {
            setRespectedColorList([]);
            return
        }

        setLoadingColors(prev => ({
            ...prev,
            [color]: true
        }));
        setRespectedColorList([]);

        const inputName = modifiedColors[color]?.name?.toLowerCase().trim() || '';

        try {
            // First, look for exact match(es)
            const exactMatches = colorJSON.filter(c =>
                c.name.toLowerCase().trim() === inputName
            );

            let selectedColors;

            if (exactMatches.length > 0) {
                selectedColors = exactMatches;
            } else {
                // Fallback to partial match
                const regex = new RegExp(`\\b${inputName}\\b`, 'i'); // 'i' for case-insensitive

                selectedColors = colorJSON.filter(c =>
                    regex.test(c.name)
                );
            }

            if (selectedColors.length > 0) {
                // Store the result list
                setRespectedColorList(prev => ({
                    ...prev,
                    [color]: selectedColors
                }));

                // Set the first match’s hex to the color
                if (selectedColors.length === 1) {
                    setModifiedColors(prev => ({
                        ...prev,
                        [color]: {
                            ...(prev[color] || {}),
                            hex: selectedColors[0].hex
                        }
                    }));
                }
            } else {
                alert('No matching colors found.');
            }
        } catch (error) {
            console.error('Error finding hex codes locally:', error);
        } finally {
            setLoadingColors(prev => ({
                ...prev,
                [color]: false
            }));
        }
    };

    const [isHovered, setIsHovered] = useState([])

    const handleHoverOut = (color) => {
        setIsHovered(prev => prev.filter(c => c !== color));
    };


    const handleHover = (color) => {
        setIsHovered(prev => [...new Set([...prev, color])]); // ensures no duplicates
    };




    const [isFocused, setIsFocused] = useState()

    const handleFocus = (color) => {
        setIsFocused(color)
    }

    const handleSave = async () => {
        try {
            const response = await axios.post(`${apiBaseUrl}/postModifyColor`, modifiedColors);
            // alert(response.data.message);
            if (response.status === 200) {
                handleCancel();
            }
        } catch (error) {
            console.error('Error saving :', error);
            alert('Failed to save ');
        }
    }

    const navigate = useNavigate(null)

    const handleCancel = () => {
        navigate('/dashboard')
    }

    return (
        <div className='w-screen h-screen flex justify-center items-center overflow-hidden'>
            <div className='w-full h-full flex flex-col gap-5 overflow-auto p-5'>
                <div className='w-full h-full flex flex-col  border rounded-lg shadow-md text-nowrap overflow-auto'>
                    <div className='w-full flex'>
                        <div className='w-1/3 p-3 px-5 font-[600] text-lg bg-[#dcdcdc]'>Available Colors</div>
                        <div className='w-1/3 p-3 px-5 font-[600] text-lg bg-[#dcdcdc]'>Modified Color</div>
                        <div className='w-1/3 p-3 px-5 font-[600] text-lg bg-[#dcdcdc]'>Modified Color</div>
                    </div>
                    <div className='w-full flex flex-col overflow-auto'>
                        {colors && colors.map((color, idx) => (
                            <div key={idx} className='w-full flex border-b'>
                                <div className='w-1/3 p-3 px-5 border-r'>{color}</div>
                                <div className={`relative w-1/3 flex justify-center items-center p-3 px-5 ${isFocused === color ? 'bg-[#fff]' : 'bg-[#f6f6f6]'}`}>
                                    <input type="text"
                                        className='w-full focus:outline-none bg-transparent text-center'
                                        value={modifiedColors[color]?.name || ''}
                                        onFocus={() => handleFocus(color)}
                                        onChange={(e) => handleChangeColor(e, color)} />
                                    {modifiedColors[color]?.name && (
                                        <div className='absolute right-2 p-2 rounded-full border bg-[#dfdfdf] cursor-pointer hover:bg-[#bdbdbd]' onClick={() => handleGetHexCodes(color)}>
                                            <img className='w-[1rem]' src={hexImg} alt="" />
                                        </div>
                                    )}
                                    {respectedColorList?.[color]?.length > 1 && (
                                        <div className="absolute top-full shadow-md bg-white border z-10 max-h-[10rem] overflow-y-auto w-full">
                                            {respectedColorList[color].map((opt, i) => (
                                                <div
                                                    key={i}
                                                    className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
                                                    onClick={() => {
                                                        // Set selected value
                                                        setModifiedColors(prev => ({
                                                            ...prev,
                                                            [color]: {
                                                                ...(prev[color] || {}),
                                                                // name: opt.name,
                                                                hex: opt.hex
                                                            }
                                                        }));
                                                        // Clear dropdown
                                                        setRespectedColorList([]);
                                                    }}
                                                >
                                                    {opt.name} — {opt.hex}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className={`relative w-1/3 p-3 flex justify-center items-center px-5 border-l-2 ${isFocused === color ? 'bg-[#fff]' : 'bg-[#f6f6f698]'}`}>
                                    <input type="text"
                                        className='w-full focus:outline-none bg-transparent text-center'
                                        value={modifiedColors[color]?.hex || ''}
                                        onFocus={() => handleFocus(color)}
                                        onChange={(e) => handleChangeHex(e, color)} />
                                    {loadingColors[color] && (
                                        <div className='absolute text-[#929292]'>fetching color code...</div>
                                    )}
                                    {modifiedColors[color]?.hex && (
                                        <div
                                            className={`absolute cursor-pointer border transition-all duration-5000 ease-in-out 
                                            ${isHovered.includes(color) ? 'inset-0' : 'p-2 right-2'}`}
                                            style={{
                                                backgroundColor: modifiedColors[color].hex,
                                            }}
                                            onMouseEnter={() => handleHover(color)}
                                            onMouseLeave={() => handleHoverOut(color)}
                                        >
                                            <img className="w-[1rem] opacity-0" src={hexImg} alt="" />
                                        </div>
                                    )}


                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='w-full h-max flex gap-5 font-[600]'>
                    <button className='w-1/2 bg-[#ccc] p-3 rounded-lg shadow-md hover:bg-opacity-50' onClick={handleCancel}>Cancel</button>
                    <button className='w-1/2 bg-[#c30000] p-3 rounded-lg text-[#fff] shadow-md hover:bg-opacity-50' onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    )
}

export default UpdateColors